import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { PurchaseOrderLineManufacturingNarrative } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

/**
 * The Manufacturing Narrative tab's own service - separate from PurchaseOrderLineNarrativeService
 * so the two tabs cannot overwrite each other's unsaved edits (each form saves every field it
 * loaded).
 */
@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderLineManufacturingNarrativeService extends TmsWebBaseEditService<
  PurchaseOrderLineManufacturingNarrative,
  PurchaseOrderLineManufacturingNarrative
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseOrderLineManufacturingNarrative', $localize`Manufacturing Narrative`);
  }
}
